import { useState, useEffect, useCallback, useRef } from "react";
import { payrollApi } from "../../lib/api";

/** Loads (or lazily creates) the PayrollPeriod for a date range, and exposes
 * the transition/payDate-patch actions the accountant workspace needs. */
export function usePayrollPeriod(fromDate, toDate) {
  const [period, setPeriod] = useState(null);
  const [loading, setLoading] = useState(false);
  const creatingRef = useRef(false);

  const load = useCallback(async () => {
    if (!fromDate || !toDate || creatingRef.current) return;
    setLoading(true);
    creatingRef.current = true;
    try {
      let p = await payrollApi.getPeriodByRange(fromDate, toDate);
      if (!p) p = await payrollApi.createPeriod({ startDate: fromDate, endDate: toDate });
      setPeriod(p);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
      creatingRef.current = false;
    }
  }, [fromDate, toDate]);

  useEffect(() => { load(); }, [load]);

  const patchPayDate = async (payDate) => {
    if (!period) return;
    try {
      setPeriod(await payrollApi.patchPeriod(period.id, { payDate: payDate || null }));
    } catch (err) {
      console.error(err);
    }
  };

  const transition = async (toStatus, extra = {}) => {
    if (!period) return null;
    const updated = await payrollApi.transitionPeriod(period.id, { toStatus, ...extra });
    setPeriod(updated);
    return updated;
  };

  return { period, loading, reload: load, patchPayDate, transition };
}
